import React from "react";
import {
  Container,
  Box,
  Card,
  CardMedia,
  CardContent,
  Typography,
} from "@mui/material";
import parseBlogContent from './parseBlogContent';
import blog1 from "../../assests/blog2.jpeg";
import { useTranslation } from "react-i18next";

const Blog1 = () => {
  const { t, i18n } = useTranslation();

  // Helper function to safely render HTML content within Typography
  const renderHTML = (key, props = {}) => {
    return (
      <Typography
        component="div"
        variant="body1"
        color="text.secondary"
        sx={{ mb: 3 }}
        {...props}
      >
        {parseBlogContent(t(key), i18n.language)}
      </Typography>
    );
  };

  return (
    <Container component="article" maxWidth="md" sx={{ p: 0 }}>
      <Box sx={{ my: 10 }}>
        <Card sx={{ backgroundColor: "transparent", p: { xs: 1, md: 5 } }}>
          <Typography
            variant="h1"
            sx={{
              mb: 5,
              color: "black",
              fontSize: { xs: "1.75rem", sm: "2.25rem" },
            }}
          >
            {t("title1")}
          </Typography>
          <CardMedia
            component="img"
            image={blog1}
            alt={t("App Development")}
            sx={{ height: "auto", width: "100%", mb: 5 }}
          />
          <CardContent>
            {renderHTML("description1")}
            <h2 variant="h2" color="text.secondary" sx={{ mb: 3 }}>
              {t("subTitle1")}
            </h2>

            {renderHTML("subDescription1")}
            <h3 variant="h5" color="text.secondary" style={{ marginBottom: 5 }}>
              {t("Our Services")}
            </h3>
            {renderHTML("listHeading1")}
            {renderHTML("listDescription1")}
            {renderHTML("listHeading2")}
            {renderHTML("listDescription2")}
            {renderHTML("listHeading3")}
            {renderHTML("listDescription3")}
            {renderHTML("listHeading4")}
            {renderHTML("listDescription4")}
            {renderHTML("listHeading5")}
            {renderHTML("listDescription5")}
            {renderHTML("description2")}
            <h3 color="text.secondary" sx={{ mb: 3 }}>
              {t("subTitle2")}
            </h3>

            {renderHTML("subDescription3")}
            <h3 color="text.secondary" sx={{ mb: 3 }}>
              {t("subTitle3")}
            </h3>

            {renderHTML("Driving Digital Innovation")}
            {renderHTML("subDescription4")}
            {renderHTML("Get Started with Thas Multitech Today!")}
            {renderHTML("subDescription5")}
          </CardContent>
        </Card>
      </Box>
    </Container>
  );
};

export default Blog1;
